<template>
  <div class="relative items-center p-4 bg-white dark:bg-slate-900">

    <div v-if="selectedBoard && loadingSelection" class="h-full w-full overflow-hidden grid place-items-center absolute backdrop-blur-[5px] z-[10] cursor-none">
      <p class="text-sm font-bold ">
        Loading
      </p>
    </div>
    <div class="text-left rtl:text-right w-full h-full">
      <div class="flex justify-between">

        <h3 class="text-base text-slate-800 dark:text-slate-100 capitalize text-more" :class="dynamicClasses">
          {{ $t('CONTACT_PANEL.MORE_DETAILS') }}
        </h3>
        <div class="flex justify-between">
          <a :href="contactProfileLink" class="fs-default" target="_blank" rel="noopener nofollow noreferrer">

            <woot-button icon="fullscreen" viewBox="0 0 15 24" variant="clear" color-scheme="secondary" class="open-icon"
              :class="dynamicClasses" />
          </a>
          <woot-button icon="dismiss" class="button modal--close clear button--only-icon secondary"
            :class="dynamicClasses" @click="closePanel" />
        </div>
      </div>

      <!-- <div class="relative-position">
        <div class="relative">
          <woot-button
            v-tooltip="$t('EDIT_CONTACT.BUTTON_LABEL')"
            title="$t('EDIT_CONTACT.BUTTON_LABEL')"
            icon="edit"
            variant="smooth"
            size="small"
            @click="toggleEditModal"
            class="custom-button"
            :class="dynamicClasses"
          />

          <woot-button
            icon="more-vertical"
            v-tooltip="$t('EDIT_CONTACT.MORE_DETAILS')"
            class="custom-button more-vertical-icon clear secondary rtl:rotate-180"
            :class="dynamicClasses"
            @click="toggleOptionsVisibility"
          />

          <div
            v-if="showOptions"
            class="flex items-center gap-2 options-container"
            v-on-clickaway="closeOptions"
          >
            <woot-button
              v-tooltip="$t('CONTACT_PANEL.NEW_MESSAGE')"
              title="$t('CONTACT_PANEL.NEW_MESSAGE')"
              icon="chat-messenger"
              :viewBox="'0 0 24 24'"
              size="small"
              @click.stop="handleChatMessengerClick"
            />

            <woot-button
              v-tooltip="$t('CONTACT_PANEL.MERGE_CONTACT')"
              title="$t('CONTACT_PANEL.MERGE_CONTACT')"
              icon="merge"
              variant="smooth"
              size="small"
              color-scheme="secondary"
              :disabled="uiFlags.isMerging"
              @click.stop="handleMergeClick"
            />
            <woot-button
              v-if="isAdmin"
              v-tooltip="$t('DELETE_CONTACT.BUTTON_LABEL')"
              title="$t('DELETE_CONTACT.BUTTON_LABEL')"
              icon="delete"
              variant="smooth"
              size="small"
              color-scheme="alert"
              :disabled="uiFlags.isDeleting"
              @click.stop="handleDeleteClick"
            />

            <woot-button
              v-if="isConversationPage"
              v-tooltip="$t('EDIT_CONTACT.SET_REMAINDER')"
              title="$t('EDIT_CONTACT.SET_REMAINDER')"
              icon="calendar-clock"
              color-scheme="secondary"
              size="small"
               @click.stop="handleRemainderClick"
            />
            <woot-button
               v-if="isContactPage"
              v-tooltip="$t('ADD_AGENT.BUTTON_LABEL')"
              :title="$t('ADD_AGENT.TITLE')"
              :icon="userIcon"
              color-scheme="secondary"
              variant="smooth"
              size="small"
              @click.stop="handletoggleDropdown"
            />

            <draggable-file
              :show="showDragmodal"
              :formatted="formattedTime"
              :hangup="CallHangup"
              :selectedContact="selectedContact"
            />
          </div>
        </div>
      </div> -->
      <!-- <div class="flex justify-center">
        <thumbnail
          v-if="showAvatar"
          :src="contact.thumbnail"
          size="90px"
          :username="contact.name"
          :status="contact.availability_status"
        />
      </div> -->

      <div class="mt-2 w-full">
        <!-- <div class="flex gap-1 items-center justify-center mb-2">
          
        
        </div>
        <div
          v-if="showAvatar"
          class="flex items-center mb-2 gap-1 justify-between"
        >
          <div class="flex gap-1">
            <fluent-icon
              v-if="contact.created_at"
              v-tooltip.right="
                `${$t('CONTACT_PANEL.CREATED_AT_LABEL')} ${dynamicTime(
                  contact.created_at
                )}`
              "
              icon="info"
              size="20"
              class="blue-color has-tooltip mt-0.5 position-relative"
            />
            <h3
              class="text-base text-slate-800 dark:text-slate-100 capitalize whitespace-normal my-0 lightgrey pl-2 cursor-pointer"
                :title="contact.name.length > 15 ? contact.name : ''"
            >
              {{ contact.name.length>15? contact.name.slice(0,15)+'...':contact.name }}
            </h3>
          </div>
          <div v-if="!this.isSpecialRoute">
            <a
              :href="contactProfileLink"
              class="fs-default"
              target="_blank"
              rel="noopener nofollow noreferrer"
            >
              <woot-button
                size="tiny"
                icon="open"
                variant="clear"
                color-scheme="secondary"
              />
            </a>
          </div>
        </div> -->

        <!-- <p
          v-if="additionalAttributes.description"
          class="break-words lightgrey relative group"
          
        >
        Bio: 
    {{ additionalAttributes.description.length > 50 
        ? additionalAttributes.description.slice(0, 50) + "..." 
        : additionalAttributes.description }}

        <span
         v-if="additionalAttributes.description.length > 50"
         class="hidden group-hover:block absolute top-6 left-0 bg-white dark:bg-gray-800 text-black dark:text-black p-2 shadow-md  max-w-sm z-10 border border-gray-300 dark:border-gray-600 "
         style="white-space: normal; word-break: break-word;"
       >
      {{ additionalAttributes.description }}
    </span>
        </p> -->
        <div class="flex justify-between items-start mb-6  bg-slate-25 rounded-md p-2 dark:bg-slate-900">
          <div class="flex gap-3">
            <div class="mr-4">
              <thumbnail v-if="showAvatar" :src="contact.thumbnail" size="90px" :username="contact.name"
                :status="contact.availability_status" />
            </div>
            <div>
              <div class="flex items-center flex-wrap">
                <h2 class="text-xl font-semibold text-slate-800 dark:text-slate-100 break-all">
                  {{ contact.name }}
                </h2>
                <span class="text-gray-500 ml-2">{{ additionalAttributes.team }}</span>
              </div>
              <div class="w-full overflow-hidden">
                <p class="text-gray-600 dark:text-gray-400 mt-1 break-all overflow-hidden text-sm">
                  {{ additionalAttributes.description }}
                </p>
              </div>
              <!-- Add labels section -->
              <div class="flex mt-2 gap-2">
                <contact-label :contact-id="contact.id" class="contact-labels" />
              </div>
            </div>
          </div>
          <div class="flex gap-1 p-2">
            <woot-button v-tooltip="'Jio Call'" :key="showCallButton" :icon="currentIcon" :viewBox="'0 0 15.681 15.684'"
              size="small" @click="initializeDomesticCallModal" v-tooltip.top-end="$t('Indian domestic calls')"
              :title="$t('Indian domestic calls')" :classNames="'jio-call-button-class'" />
            <woot-button v-tooltip="'Call'" :key="showCallButton" :title="$t(calltitle)" :icon="currentIcon"
              :viewBox="'0 0 15.681 15.684'" size="small" @click="startupClient" :classNames="'call-button-class'" />
            <woot-button v-tooltip="$t('EDIT_CONTACT.BUTTON_LABEL')" title="$t('EDIT_CONTACT.BUTTON_LABEL')"
              icon="edit-contact" size="small" @click="toggleEditModal" :classNames="'edit-button-class'" />
          </div>

        </div>

        <div class="grid grid-cols-1 sm:grid-cols-2  gap-2 mb-6">
          <!-- Email -->
          <div>
            <div class="flex items-start">
              <div class="icon-text mr-1 p-1 rounded dark:bg-transparent">
                <fluent-icon icon="mail" size="10" />
              </div>
              <div>
                <p class="text-slate-500 text-sm mb-0 font-bold" style="font-size: 12px;">Mail</p>
              </div>
            </div>
            <p v-tooltip="contact?.email && contact.email.length > 22 ? contact.email : ''" class="text-slate-400 dark:text-gray-300 break-words whitespace-normal truncate max-w-44 text-nowrap">
              {{ contact.email || 'Not Available' }}
            </p>
          </div>

          <!-- Phone -->
          <div>
            <div class="flex items-start ml-[3.5rem]">
              <div class="icon-text mr-2 p-1 rounded">
                <fluent-icon icon="call" size="10" />
              </div>
              <div>
                <p class="text-slate-500 text-sm mb-0 font-bold" style="font-size: 12px;">Contact No.</p>
              </div>
            </div>
            <p class="text-slate-400 dark:text-gray-300 truncate max-w-44 text-nowrap ml-[3.5rem]">
              {{ contact.phone_number || 'Not Available' }}
            </p>
          </div>

          <!-- Location -->
          <div>
            <div class="flex items-start">
              <div class="icon-text mr-2 p-1 rounded">
                <fluent-icon icon="map" size="10" />
              </div>
              <div>
                <p class="text-slate-500 text-sm mb-0 font-bold" style="font-size: 12px;">Location</p>
              </div>
            </div>
            <p class="text-slate-400 dark:text-gray-300 truncate max-w-44 text-nowrap">
              {{ location || 'Not Available' }}
            </p>
          </div>

          <!-- Meeting time -->
          <div>
            <div class="flex items-start ml-[3.5rem]">
              <div class="icon-text mr-2 rounded">
                <fluent-icon icon="clock" size="20" class=" translate-x-[19%] translate-y-[18%]" />
              </div>
              <div>
                <p class="text-slate-500 text-sm mb-0 font-bold" style="font-size: 12px;">Set Reminder</p>
              </div>
            </div>
            <p class="text-slate-400 dark:text-gray-300 ml-[3.5rem]">
              {{ this.setReminder || '12:05 PM' }}
            </p>
          </div>
        </div>
        <div class="flex gap-4 mb-[1rem]">
          <!-- Boards Dropdown -->
          <!-- <div>
            <label>Select Boards</label>
            <select v-model="selectedBoard" @change="handleChange" class="border px-2 py-1">
              <option disabled value="">Select a Board</option>
              <option v-for="board in boards" :key="board.id" :value="board.id">
                {{ board.name }}
              </option>
            </select>
          </div> -->
          <!-- <div style="width: 300px;">
          <label>Select Boards</label>
            <multiselect
              v-model="selectedBoard"
              :options="boards"
              track-by="id"
              label="name"
              select-label="Select"
              deselect-label=""
              placeholder="Select a Board"
              :allow-empty="false"
              :option-disabled="isOptionDisabled"
              @input="handleChange"
            />
        </div> -->
     
        <div class="board-selector">
        <label>Select Boards</label>
        <woot-button
        @click="toggleBoardModal"
        variant="smooth"
        size="medium"
        color-scheme="primary"
        class="board-button"

  >
       
  <span class="board-button__text">
      {{ selectedBoard ? selectedBoard.name : 'Select a Board' }}
      </span>
      </woot-button>
      </div>
      <transition name="fade">
      <board-selection-modal
      v-if="showBoardModal"
      :boards="boards"
      :selected-board="selectedBoard"
      @close="toggleBoardModal"
      @select="handleBoardSelection"
      @remove="handleBoardRemove"
  
      />
     </transition>



          <!-- States Dropdown (Populated after Board selection) -->
          <!-- <div>
            <label>Select Pipeline</label>
            <select v-model="selectedState" @change="moveItem"  class="border px-2 py-1" :disabled="!stateList.length">
              <option disabled value="">Select a Status</option>
              <option v-for="state in stateList" :key="state.id" :value="state.id">
                {{ state.name }}
              </option>
            </select>
          </div> -->
        <!-- <div style="width: 300px;">
          <label>Select Pipeline</label>
            <multiselect
              v-model="selectedState"
              :options="stateList"
              track-by="id"
              label="name"
              select-label="Select"
              deselect-label=""
              placeholder="Select a Status"
              :allow-empty="false"
              @input="moveItem"
            />
        </div> -->

        <div class="board-selector">
  <label>Select Pipeline</label>
  <woot-button
    @click="toggleStatusModal"
    variant="smooth"
    size="medium"
    color-scheme="primary"
    class="board-button"
  >
  <span class="board-button__text">
    {{ selectedStatus ? selectedStatus.name : 'Select a Status' }}
    </span>
  </woot-button>
</div>
<transition name="fade">
  <status-selection-modal
    v-if="showStatusModal"
    :states="stateList"
    :selected-status="selectedStatus"
    @close="toggleStatusModal"
    @select="handleStatusSelection"
  />
</transition>

<div class="board-selector">
  <label>Select State</label>
  <woot-button
    @click="toggleStateModal"
    variant="smooth"
    size="medium"
    color-scheme="primary"
    class="board-button"
  >
  <span class="board-button__text">
    {{ selectedState ? selectedState.name : 'Select a State' }}
    </span>
  </woot-button>
</div>
<transition name="fade">
  <state-selection-modal
    v-if="showStateModal"
    :states="state"
    :selected-state="selectedState"
    @close="toggleStateModal"
    @select="handleStateSelection"
     @remove="handleStateRemove"
  />
</transition>
          <!-- Move Button -->
          <!-- <div class="flex items-center flex-col ">
            <div class="invisible">box</div>
            <button :disabled="!canMove" @click="moveItem"
              class="button label--add smooth h-full tiny primary p-[19px]">
             Move To Boards
            </button>
            <woot-submit-button
              :disabled="isTransfering ? true : !canMove" @click="moveItem"
              :loading="isTransfering"
              :button-text="isTransfering ? 'Moving':'Move To Board'"
              class="move_to_board "
            />
          </div> -->

        </div>
        <div class="flex gap-12 flex-wrap">
          <div>
            <p style="font-size: 12px; font-weight: 500;">More Links</p>
            <div class="flex items-center w-full mt-2 gap-1">
              <woot-button v-tooltip="$t('CONTACT_PANEL.NEW_MESSAGE')" title="$t('CONTACT_PANEL.NEW_MESSAGE')"
                icon="chat-messenger" :isBlue="true" size="small" @click="toggleConversationModal"
                :classNames="'contact-modal-links'" />
              <woot-button v-if="isAdmin" v-tooltip="$t('ADD_AGENT.BUTTON_LABEL')" :title="$t('ADD_AGENT.TITLE')"
                :icon="userIcon" :isBlue="true" size="small" @click="toggleDropdown"
                :classNames="{'contact-modal-links':true ,
                  'contact-modal-selected': assignedAgent !== null ? true : false
                }"
                />
              <woot-button v-tooltip="$t('EDIT_CONTACT.SET_REMAINDER')" title="$t('EDIT_CONTACT.SET_REMAINDER')"
                icon="calendar-clock" :isBlue="true" size="small" @click="openRemainderModal"
                :classNames="'contact-modal-links'" />
              <woot-button v-tooltip="$t('CONTACT_PANEL.MERGE_CONTACT')" title="$t('CONTACT_PANEL.MERGE_CONTACT')"
                icon="merge-contact" size="small" :isBlue="true" :viewBox="'0 0 15.444 15.444'"
                :disabled="uiFlags.isMerging" @click="openMergeModal" :classNames="'contact-modal-links'" />

              <woot-button v-if="isAdmin" v-tooltip="$t('DELETE_CONTACT.BUTTON_LABEL')"
                title="$t('DELETE_CONTACT.BUTTON_LABEL')" icon="delete-contact" :viewBox="'0 0 10.456 13.444'"
                :isBlue="true" size="small" :disabled="uiFlags.isDeleting" @click="toggleDeleteModal"
                :classNames="'contact-modal-links bg-[rgb(248,248,248)] dark:bg-transparent'" />

              <draggable-file :show="showDragmodal" :formatted="formattedTime" :hangup="CallHangup"
                :selectedContact="selectedContact" />
            </div>

          </div>
          <div>
            <p style="font-size: 12px; font-weight: 500;">Social Links</p>
            <div>
              <social-icons :social-profiles="socialProfiles"
                custom-class="p-2 bg-slate-25 rounded-md dark:bg-slate-900" />
            </div>
          </div>
        </div>
        <!-- <div class="mb-3 lightgrey">
          <contact-info-row
            :href="contact.email ? `mailto:${contact.email}` : ''"
            :value="contact.email"
            icon="mail"
            size="20"
            emoji="✉️"
            :title="$t('CONTACT_PANEL.EMAIL_ADDRESS')"
            show-copy
          />
          <contact-info-row
            :href="contact.phone_number ? `tel:${contact.phone_number}` : ''"
            :value="contact.phone_number"
            icon="call"
            size="20"
            emoji="📞"
            :title="$t('CONTACT_PANEL.PHONE_NUMBER')"
            show-copy
          />
          <contact-info-row
            v-if="contact.identifier"
            :value="contact.identifier"
            icon="contact-identify"
            size="20"
            emoji="🪪"
            :title="$t('CONTACT_PANEL.IDENTIFIER')"
          />
          <contact-info-row
            :value="additionalAttributes.company_name"
            icon="building-bank"
            size="20"
            emoji="🏢"
            :title="$t('CONTACT_PANEL.COMPANY')"
          />
          <contact-info-row
            v-if="location || additionalAttributes.location"
            :value="location || additionalAttributes.location"
            icon="map"
            size="20"
            emoji="🌍"
            :title="$t('CONTACT_PANEL.LOCATION')"
          />
          <contact-info-row
            :value="formattedChatDateTime"
            icon="clock"
            size="20"
            :viewBox="'0 0 15 15'"
            emoji="🏢"
            :title="$t('CONTACT_PANEL.DEMOTIME')"
          />
        </div> -->
      </div>

      <edit-contact v-if="showEditModal " :show="showEditModal" :contact="contact" @cancel="toggleEditModal" />
      <new-conversation v-if="contact.id" :show="showConversationModal" :contact="contact"
        @cancel="toggleConversationModal" />
      <contact-merge-modal v-if="showMergeModal" :primary-contact="contact" :show="showMergeModal"
        @close="toggleMergeModal" />
      <set-remainder-modal v-if="showRemainderModal" :primary-contact="contact" :show="showRemainderModal" :currentChat="currentChat"
        :date-part="datePart" :time-without-z="timeWithoutZ" @close="toggleReminderModal"
        @success-message="successMessageData" />
    </div>
    <woot-delete-modal
      v-if="showDeleteModal"
      :show.sync="showDeleteModal"
      :on-close="closeDelete"
      :on-confirm="confirmDeletion"
      :title="$t('DELETE_CONTACT.CONFIRM.TITLE')"
      :message="$t('DELETE_CONTACT.CONFIRM.MESSAGE')"
      :message-value="confirmDeleteMessage"
      :confirm-text="$t('DELETE_CONTACT.CONFIRM.YES')"
      :reject-text="$t('DELETE_CONTACT.CONFIRM.NO')"
    />
    <div v-if="isDropdownVisible" class="multiselect-wrap--small mt-2">
      <multiselect-dropdown :options="agentsList" :selected-item="assignedAgent"
        :multiselector-title="$t('AGENT_MGMT.MULTI_SELECTOR.TITLE.AGENT')"
        :multiselector-placeholder="$t('AGENT_MGMT.MULTI_SELECTOR.PLACEHOLDER')" :no-search-result="$t('AGENT_MGMT.MULTI_SELECTOR.SEARCH.NO_RESULTS.AGENT')
          " :input-placeholder="$t('AGENT_MGMT.MULTI_SELECTOR.SEARCH.PLACEHOLDER.AGENT')
          " @click="onClickAssignAgent" />
    </div>

    <div v-if="showModal" class="modal">
      <div class="modal-content">
        <woot-button icon="dismiss" class="button modal--close clear button--only-icon secondary" @click="closeModal" />

        <h3 class="modal-title">{{ $t('Select Inbox') }}</h3>

        <!-- Loading Inboxes -->
        <div v-if="isLoading" class="loader-container">
          <div class="loader">
            <fluent-icon icon="spinner" size="24" class="spinner-icon animate-spin" />
          </div>
          <p class="loader-text">Loading inboxes...</p>
        </div>

        <!-- Inbox Dropdown -->
        <div v-else-if="inboxes && inboxes.length > 0" class="custom-dropdown">
          <multiselect v-model="selectedInbox" track-by="value" label="label"
            :placeholder="$t('Select the Jio inbox from here...')" selected-label="" select-label="" deselect-label=""
            :max-height="160" :close-on-select="true" :options="inboxes" :disabled="isCreatingCall">
            <template slot="singleLabel" slot-scope="{ option }">
              <div class="inbox-option" style="display: flex; justify-content: flex-start;">
                <fluent-icon icon="call" size="15" class="inbox-icon" />
                <span class="inbox-label">{{ option.label }}</span>
              </div>
            </template>
            <template slot="option" slot-scope="{ option }">
              <div class="inbox-option" style="display: flex; justify-content: flex-start;">
                <fluent-icon icon="call" size="15" class="inbox-icon" />
                <span class="inbox-label">{{ option.label }}</span>
              </div>
            </template>
            <template slot="noResult">
              <span>{{ $t('NO_RESULTS') }}</span>
            </template>
          </multiselect>
        </div>
        <div v-else class="no-results">
          <p>{{ $t('NO_RESULTS') }}</p>
        </div>

        <p v-if="selectedInbox" class="selected-inbox">
          Selected Jio Inbox: {{ selectedInbox.label }}
        </p>
        <p class="selected-agent">
          Agent: {{ $t('Call using your account') }}
        </p>

        <!-- Loader for Call Creation -->
        <div v-if="isCreatingCall" class="loader-container">
          <div class="loader">
            <fluent-icon icon="phone" size="24" class="phone-icon animate-pulse" />
            <fluent-icon icon="spinner" size="24" class="spinner-icon animate-spin" />
          </div>
          <p class="loader-text">Connecting your call...</p>
        </div>

        <!-- Success Message -->
        <transition name="fade">
          <p v-if="successMessage" class="success-message">
            <fluent-icon icon="checkmark-circle" size="20" class="success-icon" />
            {{ successMessage }}
          </p>
        </transition>

        <!-- Error Message -->
        <transition name="fade">
          <p v-if="errorMessage" class="error-message">
            <fluent-icon icon="call-end" size="20" class="error-icon" />
            {{ errorMessage }}
          </p>
        </transition>
        <woot-button v-if="selectedInbox && contact.id && !isCreatingCall" @click="createConversation" variant="smooth"
          color-scheme="primary" size="medium">
          {{ $t('Create call') }}
        </woot-button>
      </div>
    </div>
  </div>
</template>
<script>
import { mixin as clickaway } from 'vue-clickaway';
import timeMixin from 'dashboard/mixins/time';
import ContactInfoRow from './ContactInfoRow';
import ContactLabel from 'dashboard/routes/dashboard/contacts/components/ContactLabels.vue';
import Thumbnail from 'dashboard/components/widgets/Thumbnail.vue';
import SocialIcons from './SocialIcons';
import DraggableFile from '../../../../components/widgets/WootWriter/Draggable.vue';
import EditContact from './EditContact';
import NewConversation from './NewConversation';
import ContactMergeModal from 'dashboard/modules/contact/ContactMergeModal';
import SetRemainderModal from 'dashboard/modules/contact/SetRemainderModal';
import alertMixin from 'shared/mixins/alertMixin';
import adminMixin from '../../../../mixins/isAdmin';
import { mapGetters } from 'vuex';
import { getCountryFlag } from 'dashboard/helper/flag';
import MultiselectDropdown from 'shared/components/ui/MultiselectDropdown.vue';
import axios from 'axios';
import { tr } from 'date-fns/locale';
import BoardSelectionModal from './BoardSelectionModal.vue';
import StatusSelectionModal from './StatusSelectionModal.vue';
import StateSelectionModal from './StateSelectionModal.vue';
let token;
let device;
let call;
export default {
  components: {
    ContactLabel,
    ContactInfoRow,
    EditContact,
    Thumbnail,
    SocialIcons,
    NewConversation,
    ContactMergeModal,
    SetRemainderModal,
    DraggableFile,
    MultiselectDropdown,
    BoardSelectionModal,
    StatusSelectionModal,
    StateSelectionModal,
  },
  mixins: [alertMixin, adminMixin, clickaway, timeMixin],
  props: {
    contact: {
      type: Object,
      default: () => ({}),
    },
    channelType: {
      type: String,
      default: '',
    },
    showAvatar: {
      type: Boolean,
      default: true,
    },
    showCloseButton: {
      type: Boolean,
      default: true,
    },
    closeIconName: {
      type: String,
      default: 'dismiss',
    },
    pipelineContact: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      showEditModal: false,
      showConversationModal: false,
      showMergeModal: false,
      showRemainderModal: false,
      showDeleteModal: false,
      showDragmodal: false,
      showCallButton: true,
      showOptions: false,
      calltitle: 'CONVERSATION.REPLYBOX.CALL',
      currentIcon: 'contact-call',
      seconds: 0,
      minutes: 0,
      hours: 0,
      selectedContact: null,
      conversationId: '',
      datePart: '',
      timeWithoutZ: '',
      updatedDate: '',
      updatedTime: '',
      demo_time: null,
      formatted: false,
      isDropdownVisible: false,
      agentsList: [],
      assignedAgent: null,
      userIcon: 'user',
      inboxes: [],
      selectedInbox: null,
      showModal: false,
      // contact: this.contact,
      isLoading: false,
      isCreatingCall: false,
      successMessage: '',
      errorMessage: '',
      successTimeout: null,
      selectedAgent: null,
      selectedBoard: null,
      selectedStatus: null,
      stateList: [],
      isTransfering:false,
      loadingSelection:false,
      showBoardModal: false,
      selectedBoard: null,
      showStatusModal: false,
      showStateModal: false,
      selectedState: null,
      setReminder: ""
    };
  },
  watch: {
    formatted(newVal) {
      console.log('New Val', newVal);
      this.getConversationData();
    },
  },
  mounted() {
    this.getConversationData();
    this.formattedChatDateTime;
    this.fetchAgents();
    this.getBoards();
    this.selectBoard();
    this.getStates();
    this.fetchContactState(); 
    this.assignedAgent = this.contact?.assignee 
                         ? this.contact.assignee 
                       : (this.contact.assignee_id 
                       ? { id: this.contact.assignee_id, name: this.contact.assignee_name } 
                                : null);
  },
  computed: {
    isConversationPage() {
      return this.$route.path !== '/app/accounts/1/contacts';
    },
    isContactPage() {
      return this.$route.path === '/app/accounts/1/contacts';
    },
    formattedTime() {
      return (
        this.pad(this.hours) +
        ':' +
        this.pad(this.minutes) +
        ':' +
        this.pad(this.seconds)
      );
    },
    ...mapGetters({
      uiFlags: 'contacts/getUIFlags',
      accountId: 'getCurrentAccountId',
      baseUrl: 'getbaseUrl',
      currentUserId: 'getCurrentUserID',
      currentChat: 'getSelectedChat',
      current_userId: 'getCurrentUser',
    }),
    formattedChatDateTime() {
      this.formatted = !this.formatted;
      let date = null;
      if (this.demo_time != null) {
        date = new Date(this.demo_time);
      } else if (this.currentChat.demo_time != null) {
        const dateTimeStr = this.currentChat.demo_time;
        date = new Date(dateTimeStr);
      }

      if (date === null || isNaN(date)) {
        this.datePart = '';
        this.timeWithoutZ = '';
        this.setReminder= 'Not Available';
        return
      }
      const formattedDate = date.toLocaleDateString(navigator.language, {
        year: 'numeric',
        month: 'short',
        day: '2-digit',
      });
      const formattedTime = date
        .toLocaleTimeString(navigator.language, {
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit',
          hour12: true,
        })
        .replace('am', 'AM')
        .replace('pm', 'PM'); // Ensuring AM/PM in uppercase
      this.datePart = formattedDate;
      this.timeWithoutZ = formattedTime;
      this.setReminder= `${formattedDate}, ${formattedTime}`;
      return
    },

    currentContact() {
      return this.$store.getters['contacts/getContact'](
        this.currentChat.meta.sender.id
      );
    },
    contactProfileLink() {
      let baseUrl = `/app/accounts/${this.$route.params.accountId}/contacts/${this.contact.id}`;
      return this.pipelineContact ? `${baseUrl}?pipelineContact=true` : baseUrl;
    },
    additionalAttributes() {
      return this.contact.additional_attributes || {};
    },
    location() {
      const {
        country = '',
        city = '',
        country_code: countryCode,
      } = this.additionalAttributes;
      const cityAndCountry = [city, country].filter(item => !!item).join(', ');

      if (!cityAndCountry) {
        return '';
      }
      return this.findCountryFlag(countryCode, cityAndCountry);
    },
    socialProfiles() {
      const {
        social_profiles: socialProfiles,
        screen_name: twitterScreenName,
      } = this.additionalAttributes;

      return { twitter: twitterScreenName, ...(socialProfiles || {}) };
    },
    // Delete Modal
    confirmDeleteMessage() {
      return ` ${this.contact.name}?`;
    },
    isSpecialRoute() {
      const { path, query } = this.$route;
      // Apply special styles only to routes matching the pattern and exclude those with `page` query parameter
      return (
        path.startsWith("/app/accounts") &&
        path.includes("/contacts/") &&
        !query.page // Exclude routes with `page` query parameter
      );
    },
    iscontainIcon() {
      const { path, query } = this.$route;
      const isContactsRoute = /^\/app\/accounts\/\d+\/contacts\/?$/.test(path);
      const hasPageQuery = !!query.page;
      console.log("isContactsRoute", isContactsRoute);
      console.log("hasPage", hasPageQuery);
      console.log(isContactsRoute && hasPageQuery)
      return isContactsRoute || hasPageQuery;
    },
    dynamicClasses() {
      return this.isSpecialRoute ? "display_none" : "";
    },
    Moredetail() {
      // return !this.iscontainIcon ? "" : "display_none";
      return this.isSpecialRoute ? "" : "display_none";
    },
    boards() {
      // return this.$store.getters['pipelines/getAllBoards'];
      console.log("My Boards", this.$store.getters['pipelines/getAllBoards']);
      return [
        ...this.$store.getters['pipelines/getAllBoards'],
      ];
    },
    states() {
      // return this.$store.getters['pipelines/getAllStatus'];
      return [
        ...this.$store.getters['pipelines/getAllStatus'],
      ];
    },
    state(){
      console.log("My state", this.$store.getters['pipelines/getAllStatus']);
      // return [
      //   ...this.$store.getters['pipelines/getAllStatus'],
      // ];
      return this.$store.getters['pipelines/getAllStatus'] || [];
    },
    canMove() {
      const boardChanged = this.selectedBoard !== this.contact.board_id;
      const stateChanged = this.selectedStatus !== this.contact.status_id;

      return (
        this.selectedBoard &&
        this.selectedStatus &&
        this.stateList.length > 0 &&
        (boardChanged || stateChanged)
      );
    }
  },
  methods: {
    toggleBoardModal() {
    this.showBoardModal = !this.showBoardModal;
  },
  handleBoardSelection(board) {
    this.selectedBoard = board;
    this.showBoardModal = false;
    // this.toggleBoardModal();
    this.onBoardChange();
    this.moveItem();
  },
  closeDropdown() {
      this.showBoardModal = false;
    },
    toggleStatusModal() {
    this.showStatusModal = !this.showStatusModal;
  },
  handleStatusSelection(state) {
    this.selectedStatus = state;
    this.showStatusModal = false;
    this.moveItem(); // Call the move logic if needed
  },
  toggleStateModal() {
    this.showStateModal = !this.showStateModal;
  },
  handleStateSelection(state) {
    this.selectedState = state;
    this.showStateModal = false;
    this.moveItem();
  },
  async handleBoardRemove(boardId) {
      if (!boardId) return;

      const data = { boardId: null, contactId: this.contact.id };
      const statusData = { statusId: null, contactId: this.contact.id };

      try {
        const response = await this.$store.dispatch('contacts/assignBoard', data);
        const statusResponse = await this.$store.dispatch('pipelines/assignStatus', statusData);
        if (response.status === 200 && statusResponse.status === 200) {
          this.selectedBoard = null;
          this.selectedStatus = null; 
          await this.handleStateRemove();
        } 
      } catch (error) {
        this.$toast.error('An error occurred while removing the board');
      }
    },
    async handleStateRemove() {
  if (!this.contact?.id) return;

  const data = {
    stateId: null,
    contactId: this.contact.id,
    description: '',
  };

  try {
    const response = await this.$store.dispatch('contacts/assignState', data);
    if (response.status === 200) {
      this.selectedState = null;
      this.stateRemark = '';
      // this.$toast.success('State removed successfully');
      bus.$emit('on-assign'); // if needed to notify other components
    }
  } catch (error) {
    console.error('❌ Error removing state:', error);
    this.$toast.error('Failed to remove state');
  }
},

    closePanel() {
      this.$emit('toggle-panel');
      // Select and hide elements with specific classes
      const sidebarElement = document.querySelector(
        '.conversation-sidebar-wrap'
      );
      const overlayElement = document.querySelector('.modal-overlay-v1');

      if (sidebarElement) {
        sidebarElement.style.display = 'none';
      }
      if (overlayElement) {
        overlayElement.style.display = 'none';
      }

      this.$emit('cancel'); // Emit cancel event if needed by parent component
    },
    toggleMergeModal() {
      this.showMergeModal = !this.showMergeModal;
    },
    toggleReminderModal() {
      this.showRemainderModal = !this.showRemainderModal;
    },
    toggleEditModal() {
      this.showEditModal = !this.showEditModal;
    },
    onPanelToggle() {
      this.$emit('toggle-panel');
    },
    toggleConversationModal() {
      this.showConversationModal = !this.showConversationModal;
    },
    handleChatMessengerClick() {
      this.toggleConversationModal();
      this.closeOptions();
    },
    handleMergeClick() {
      this.openMergeModal();
      this.closeOptions();
    },
    handleDeleteClick() {
      this.toggleDeleteModal();
      this.closeOptions();
    },
    handleRemainderClick() {
      this.openRemainderModal();
      this.closeOptions();
    },
    handletoggleDropdown() {
      this.toggleDropdown();
      this.closeOptions();
    },
    toggleOptionsVisibility() {
      this.showOptions = !this.showOptions; // Toggles the visibility of the options div
    },
    closeOptions() {
      this.showOptions = false;
    },
    startTimer() {
      this.timerRunning = true;
      this.timer = setInterval(this.updateTimer, 1000);
    },
    stopTimer() {
      clearInterval(this.timer);
      this.timerRunning = false;
    },
    updateTimer() {
      this.seconds++;
      if (this.seconds === 60) {
        this.seconds = 0;
        this.minutes++;
        if (this.minutes === 60) {
          this.minutes = 0;
          this.hours++;
        }
      }
    },
    resetTimer() {
      this.stopTimer();
      this.selectedContact = null;
      this.seconds = 0;
      this.minutes = 0;
      this.hours = 0;
    },
    async CallHangup() {
      console.log('Call Disconnected');
      call.disconnect();
      this.$store.dispatch('contacts/toggleholdCallAvailableStatusFalse');
    },
    async updateUIAcceptedOutgoingCall() {
      this.startTimer();
    },

    async updateUIDisconnectedOutgoingCall() {
      alert('Call Ended');
      this.showDragmodal = false;
      this.resetTimer();
      console.log('::::::::::::Call has ended::::::::::');
      window.call = null
    },
    async makeOutgoingCall() {
      try {
        const contact = this.contact;
        var params = {
          To: contact.phone_number,
          account_id: this.accountId,
          contact_id: contact.id,
          userId: this.currentUserId,
        };
        if (device) {
          console.log(`Attempting to call ${params.To} ...`);
          call = await device.connect({ params });
          window.call = call
          call.on('accept', this.updateUIAcceptedOutgoingCall);
          call.on('disconnect', this.updateUIDisconnectedOutgoingCall);
          call.on('cancel', this.updateUIDisconnectedOutgoingCall);
        } else {
          console.log('Unable to make call.');
        }
      } catch (error) {
        console.error(
          'Error making outgoing call:-------------------------',
          error
        );
      }
    },

    async initializeDomesticCallModal() {
      this.showModal = true;
      this.selectedInbox = null;
      this.isLoading = true;

      try {
        const inboxResponse = await axios.get(
          `/domestic_calls/jio_inboxes?account_id=${this.accountId}`,
          {
            headers: {
              'Content-Type': 'application/json',
              'api-access-token': this.$store.getters.getCurrentUser.access_token,
            },
          }
        );

        this.inboxes = inboxResponse.data
          .map(item => ({
            label: item.name,
            value: item.id,
          }));

        this.isLoading = false;
      } catch (error) {
        console.error('Error fetching inboxes:', error);
        this.inboxes = [];
        this.isLoading = false;
        alert('Failed to fetch inboxes. Please try again later.');
      }
    },

    async createConversation() {
      if (!this.selectedInbox) {
        alert('Please select an inbox.');
        return;
      }
      console.log("sdfghjasdfghjk")
      // this.isCreatingCall = true;
      this.successMessage = '';
      this.errorMessage = '';
      if (this.successTimeout) {
        clearTimeout(this.successTimeout);
      }

      const payload = {
        inbox_id: this.selectedInbox.value,
        contact_id: this.contact.id,
        source_id: this.contact.phone_number,
        additional_attributes: {
          mail_subject: '',
        },
        message: {
          content: 'Indian Domestic Calls',
        },
        assignee_id: this.current_userId.id,
      };

      try {
        const response = await axios.get(
          `${this.baseUrl}/api/v1/accounts/${this.accountId}/search/conversations?q=${this.contact.phone_number}`,
          {
            headers: {
              'Content-Type': 'application/json',
              'api-access-token': this.$store.getters.getCurrentUser.access_token,
            },
          }
        );

        let conversationId;

        const existingConversations = response.data.payload.conversations;

        if (existingConversations && existingConversations.length > 0) {
          conversationId = existingConversations[0].id;
          console.log(`Using existing conversation ID: ${conversationId} (first found)`);
        } else {
          console.log('No existing conversation found. Creating a new one...');
          const createResponse = await axios.post(
            `${this.baseUrl}/api/v1/accounts/${this.accountId}/conversations`,
            payload,
            {
              headers: {
                'Content-Type': 'application/json',
                'api-access-token': this.$store.getters.getCurrentUser.access_token,
              },
            }
          );
          conversationId = createResponse.data.id;
        }

        const callPayload = {
          phone_number: this.contact.phone_number,
          account_id: this.accountId,
          inbox_id: this.selectedInbox.value,
          agent_id: this.current_userId.id,
          conversation_id: conversationId,
        };

        const callResponse = await axios.post(
          `${this.baseUrl}/domestic_calls/create_call`,
          callPayload,
          {
            headers: {
              'Content-Type': 'application/json',
            },
          }
        );

        console.log('Call created:', callResponse.data);
        if (callResponse.data.success === true) {
          this.successMessage = callResponse.data.message;
        }
        else {
          this.errorMessage = callResponse.data.message;
        }

        this.successTimeout = setTimeout(() => {
          this.successMessage = '';
          this.errorMessage = '';
          this.successTimeout = null;
        }, 5000);

        this.isCreatingCall = false;
      } catch (error) {
        console.error('Error:', error);
        this.isCreatingCall = false;
        alert('Failed to create conversation or call.');
      }
    },

    closeModal() {
      this.showModal = false;
      this.selectedInbox = null;
      this.isLoading = false;
      this.isCreatingCall = false;
      this.successMessage = '';
      this.errorMessage = '';
      if (this.successTimeout) {
        clearTimeout(this.successTimeout);
        this.successTimeout = null;
      }
      console.log('Modal closed');
    },

    async startupClient() {
      console.log('Requesting Access Token...');
      const contact = this.contact;
      this.selectedContact = contact;
      console.log('My COntact:::::', contact);
      let data; // Declare data variable outside the try block
      try {
        this.$store.dispatch('contacts/toggleholdCallAvailableStatusTrue');
        this.showDragmodal = !this.showDragmodal;
        this.getAudioDevices();
        console.log('Contact in yourMethod:', contact);
        console.log('User Id', this.currentUserId);
        // Remove redeclaration of data variable here
        const response = await axios.get(`${this.baseUrl}/twilio/token`, {
          params: {
            To: contact.phone_number,
            account_id: this.accountId,
            user_id: this.currentUserId,
          },
        });
        data = response.data;

        token = data.token;
        console.log('got token' + token);
        await this.intitializeDevice();
        this.makeOutgoingCall();
      } catch (err) {
        alert(data.message);
        this.showDragmodal = !this.showDragmodal;
        console.log(
          'An error occurred. See your browser console for more information.'
        );
      }
    },

    async getAudioDevices() {
      console.log('Inside getAudioDevices::::::::::::::::::::');
      await navigator.mediaDevices.getUserMedia({ audio: true });
    },
    addDeviceListeners(device) {
      device.on('registered', function () {
        console.log('Twilio.Device Ready to make and receive calls!');
      });
      device.on('error', function (error) {
        console.log('Twilio.Device Error: ' + error.message);
      });
    },
    async intitializeDevice() {
      console.log('Initializing device');
      device = new Twilio.Device(token, {
        logLevel: 1,
      });
      this.addDeviceListeners(device);
      device.register();
    },
    toggleDeleteModal() {
      this.showDeleteModal = !this.showDeleteModal;
    },
    confirmDeletion() {
      this.deleteContact(this.contact);
      this.closeDelete();
    },
    closeDelete() {
      this.showDeleteModal = false;
      this.showConversationModal = false;
      this.showEditModal = false;
    },
    findCountryFlag(countryCode, cityAndCountry) {
      try {
        const countryFlag = countryCode ? getCountryFlag(countryCode) : '🌎';
        return `${cityAndCountry} ${countryFlag}`;
      } catch (error) {
        return '';
      }
    },
    async deleteContact({ id }) {
      try {
        await this.$store.dispatch('contacts/delete', id);
        this.$emit('panel-close');
        this.showAlert(this.$t('DELETE_CONTACT.API.SUCCESS_MESSAGE'));
        if (this.$route.name !== 'contacts_dashboard') {
          this.$router.push({ name: 'contacts_dashboard' });
        }
        this.$emit('contact-deleted');
      } catch (error) {
        this.showAlert(
          error.message
            ? error.message
            : this.$t('DELETE_CONTACT.API.ERROR_MESSAGE')
        );
      }
    },
    openMergeModal() {
      this.toggleMergeModal();
    },
    pad(value) {
      return value < 10 ? '0' + value : value;
    },
    openRemainderModal() {
      this.showRemainderModal = true;
    },
    successMessageData({
      message,
      conversationId,
      formattedDate,
      formattedTime,
      demo_time,
    }) {
      if (message) {
        this.conversationId = conversationId;
        this.updatedDate = formattedDate;
        this.updatedTime = formattedTime;
        this.demo_time = demo_time;
        // this.getConversationData();
        this.showAlert(this.$t('DELETE_CONTACT.API.DEMO_MESSAGE'));
        this.formattedChatDateTime;
      }
    },
    async getConversationData() {
      const contactId = this.currentChat.meta?.sender?.id;
      let response = null;
      if (contactId) {
        try {
          response = await this.$store.dispatch(
            'contacts/getConversationData',
            contactId
          );
        } catch (error) {
          console.error('Error fetching conversation data:', error);
        }
      }
      this.demo_time = response?.demo_time || null;
    },
    toggleDropdown() {
      this.isDropdownVisible = !this.isDropdownVisible;
    },
    async fetchAgents() {
      try {
        const response = await axios.get(
          `${this.baseUrl}/api/v1/accounts/${this.accountId}/agents`,
          {
            headers:
            {
              'Content-Type': 'application/json',
              'api-access-token': this.$store.getters.getCurrentUser.access_token,
            },
          }
        );
        this.agentsList = response.data.map(agent => {
          if (agent.id === this.current_userId.id) {
            return {
              ...agent,
              name: this.$t('CONVERSATION_SIDEBAR.SELF_ASSIGN'),
              selfAssign: true,
            };
          }
          return agent;
        });
      } catch (error) {
        console.error('Error fetching agents:', error);
      }
    },
    onClickAssignAgent(selectedAgent) {
      if (selectedAgent) {
        const agentId = selectedAgent.selfAssign
          ? this.current_userId.id
          : selectedAgent.id; // Check if self-assign
        const contactId = this.contact.id;
        if (contactId && agentId) {
          axios
            .post(
              `${this.baseUrl}/api/v1/accounts/${this.accountId}/contacts/${contactId}/assignments`,
              {
                agent_id: agentId,
              },
              {
                headers: {
                  'api-access-token': this.current_userId.access_token,
                },
              }
            )
            .then(() => {
              this.showAlert('Agent successfully assigned', { success: true });
              this.assignedAgent = selectedAgent;
              bus.$emit('on-assign');
              this.isDropdownVisible = false;
            })
            .catch(error => {
              console.error('Error assigning agent:', error);
            });
        } else {
          console.error('Missing contact ID or agent ID');
        }
      }
    },
    findAssignedAgent() {
      // Logic to find and return the currently assigned agent, if applicable
      return (
        this.agentsList.find(
          agent => agent.id === this.currentChat?.assignee_id
        ) || null
      );
    },

   getStates() {
      this.$store.dispatch('pipelines/getState');
    },

    async fetchContactState() {
  if (!this.contact || !this.contact.state_id) return;

  const data = {
    id: this.contact.state_id,
    contact_id: this.contact.id,
  };

  try {
    const response = await this.$store.dispatch('contacts/getState', data);
    if (response?.data) {
      const foundState = this.state.find(state => state.id === this.contact.state_id);
if (!foundState && this.state.length > 0) {
  foundState = this.state[0]; // fallback to first state
}

this.selectedState = foundState;
    }
  } catch (error) {
    console.error('Failed to fetch state data:', error);
  }
},

async assignContactState(stateId) {
  const data = {
    stateId,
    contactId: this.contact.id,
    
  };
  try {
    const response = await this.$store.dispatch('contacts/assignState', data);
    if (response.status === 200) {
      this.selectedState = this.states.find(s => s.id === stateId);
      // this.$toast.success('State assigned successfully');
    }
  } catch (error) {
    this.$toast.error('Failed to assign state');
  }
},


    async moveItem() {
      this.isTransfering = true;
      try {
          console.log("from move item", this.selectedBoard);
        const data = {
          boardId: this.selectedBoard?.id,
          statusId: this.selectedStatus?.id,
          stateId: this.selectedState?.id,
          contactId: this.contact.id,
        };

        const response = await this.$store.dispatch('pipelines/moveStatus', data);

        this.isTransfering = false;

        if (response?.data) {
          this.showAlert(response.data.message, {
            success: response.data.success,
          });
          this.selectedStatus = this.stateList.find(
          status => status.id === response.data.data.status_id
      );
         this.selectedState = this.state.find(
         state => state.id === response.data.data.state_id
       );
          // this.selectedState ={id: response?.data?.data?.status_id ,name:  };
          bus.$emit("reloaad-pipeline");
        }
      } catch (error) {
        this.isTransfering = false;
        console.error('❌ Error in moveItem:', error);
        this.showAlert('Failed to update contact. Please try again.');
      }
},
  //  getStates() {
  //     this.$store.dispatch('pipelines/getState');
  //   },

    getBoards() {
      this.$store.dispatch('pipelines/getBoards');
    },
    // getStatus(data) {
    //   this.$store.dispatch('pipelines/getStatus',data);
    // },   
    onBoardChange() {
      this.selectedStatus = null;
  if (this.selectedBoard) {
    console.log("selected Board", this.selectedBoard);
    this.getStatus(this.selectedBoard); // No `.then()` and no auto-assign
  }
}
,
async getStatus(boardId) {
  console.log(boardId);
  this.loadingSelection = true;
  const data = {
    board_id: boardId?.id,
  }
  console.log("data========", data)
  const response = await this.$store.dispatch('pipelines/getStatusFromBoard', data);
  this.stateList = response.data.data;
  this.loadingSelection = false;
  console.log("stateList", this.stateList);
  
  let foundStatus = this.stateList.find(
    status => status.id === this.contact.status_id
  );
  
  if (!foundStatus && this.stateList.length > 0) {
    foundStatus = this.stateList[0];
  }
  
  this.selectedStatus = foundStatus;
  console.log("selectedStatus", this.selectedStatus);
  console.log("selectedStatus_name", this.selectedStatus?.name);
},
    selectBoard(){
      if (this.contact && this.contact.board_id) {
        this.selectedBoard = this.boards.find(board => board.id === this.contact.board_id);
        console.log(this.selectedBoard)
        this.onBoardChange(() => {
      // after states are loaded
      if (this.contact.status_id) {
        this.getStatus(this.selectedBoard);        
      }
    }); //pelines based on this board
      }
    },
    handleChange(){
      this.onBoardChange();
      this.moveItem();
    },
    isOptionDisabled(option) {
      console.log("option",option , option.id);
      console.log("this.selectedBoard && option.id === this.selectedBoard.id;",this.selectedBoard && option.id === this.selectedBoard.id)
    return this.selectedBoard && option.id === this.selectedBoard.id;
  },
  }
};
</script>
<style lang="scss" scoped>
.open-icon {
  position: absolute;
  right: 2.5rem;
  top: 0.7rem;
}

.jio-call-button-class {
  padding: 10px;
  background-color: blue;
}

.call-button-class {
  padding: 10px;
  background-color: rgb(4, 221, 4);
}

.edit-button-class {
  padding: 10px;
  background-color: rgb(66, 191, 240);
}

.contact-modal-links {
  padding: 2px;
  background-color: rgb(248, 248, 248);
  /* Change background color */
}
.contact-modal-selected{
  background-color: rgb(130, 138, 167) ;
}

body.dark .contact-modal-selected {
  background-color: rgb(130, 138, 167) !important;
}

body.dark .contact-modal-links {
  padding: 1px !important;
  background-color: rgb(214, 218, 240) ;
}

.icon-text {
  font-size: 2px;
  color: blue;
  background-color: #e2e8f0
}

.relative-position {
  display: flex;
  justify-content: end;
}

.dialpadModal.modal-mask {
  justify-content: center !important;
  background-color: rgba(0, 0, 0, 0.9);
  margin-top: 0px;
}

.reminder_icon {
  background-color: hsl(209 13.3% 95.3% / 1) !important;
  color: black !important;
}

body.dark .reminder_icon {
  background-color: hsl(207 5.6% 31.6% / 1) !important;
  color: white !important;
}

.dialpadModal>>>.modal-container {
  margin-top: 250px;
}

.options-container {
  display: flex;
  flex-direction: column;
  /* Stack buttons vertically */
  gap: 6px;
  position: absolute;
  /* Position absolutely relative to the button's container */
  top: 100%;
  right: 0;
  width: 98%;
  z-index: 1000;
  background-color: white;
  padding-top: 6px;
  margin-top: 1px;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  height: 172px;
  overflow: scroll;
}

.lightgrey {
  color: #aaaaaa;
}

.blue-color {
  color: #40518a;
}

.options-container::-webkit-scrollbar {
  display: none;
}

/* CHANGES  */

/* Remove margin for the last button */
.custom-button:last-child {
  margin-right: 0;
}

.custom-button {
  background-color: transparent !important;
  /* Remove background color */
  color: #aaaaaa;
  /* margin-right: 10px; */
}

.custom-button .icon {
  color: #aaaaaa;
  /* Set icon color to grey */
  font-size: 20px;
  /* Adjust icon size, increase it as needed */
}

.more-vertical-icon .icon {
  font-weight: bold;
  /* Make "more-vertical" icon bold */
  color: #aaaaaa;
}

/* .absolute-button {
  position: absolute;
  right: 18px;
  top: 2px;
} */
.text-more {
  color: #4b5155;
}
.dark .text-more{
  color: #f1f5f9;
}

.display_none {
  display: none;
}

.modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

/* Modal Content */
.modal-content {
  position: relative;
  background-color: #fff;
  padding: 24px;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  width: 100%;
  max-width: 400px;
  text-align: center;
}

body.dark .modal-content {
  background-color: #2d3748;
  color: #e2e8f0;
}

/* Close Button (Top Right) */
.modal-close-btn {
  position: absolute;
  top: 10px;
  right: 10px;
  padding: 0;
  width: 24px;
  height: 24px;
  font-size: 16px;
  line-height: 24px;
  color: #4a5568;

}

.modal-close-btn span {
  font-weight: 700;
  text-align: center;
}

body.dark .modal-close-btn {
  color: #a0aec0;
}

.modal-close-btn:hover {
  color: #2d3748;
}

body.dark .modal-close-btn:hover {
  color: #e2e8f0;
}

/* Modal Title */
.modal-title {
  font-size: 18px;
  font-weight: 600;
  margin: 0 0 16px;
  color: #2d3748;
}

body.dark .modal-title {
  color: #e2e8f0;
}

/* Custom Dropdown */
.custom-dropdown {
  margin: 0 0 16px;
}

.no-results {
  margin: 0 0 16px;
  color: #718096;
}

body.dark .no-results {
  color: #a0aec0;
}

.loader {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin: 16px 0;
  color: #4a5568;
}

body.dark .loader {
  color: #e2e8f0;
}

.animate-spin {
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

.success-message {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  font-size: 14px;
  color: #2f855a;
  background-color: #edf7ee;
  padding: 12px;
  border-radius: 6px;
  margin: 20px 0;
  transition: opacity 0.3s ease;
}

body.dark .success-message {
  color: #68d391;
  background-color: #2f855a33;
}

.success-icon {
  color: #2f855a;
  font-weight: 700;
}

.error-message {
  color: rgb(231, 68, 68);
  font-weight: 700;
}

body.dark .success-icon {
  color: #68d391;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.move_to_board{
  background-color: #40518a;
  color: whitesmoke;
  padding: 8px;
  border-radius: 8px;
  transition: background-color 0.3s ease;
}

.inbox-icon {
  margin-right: 5px;
  margin-top: 3px;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.board-selector {
  position: relative;
  max-width: 110px;

  .board-button {
    width: 100%;
    padding: 0 8px;

    &__text {
      display: inline-block;
      height:17px;
      width: 100%;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      text-align:center;
    }
  }

 .assignAgentClass{
      background-color: red;
 }
}
.button.clear.secondary:focus:not(:hover) {
  background-color: transparent !important;
  box-shadow: none !important;
  outline: none !important;
}
</style>